import React, { useState, useEffect, StrictMode } from 'react';
import { Spinner } from 'spin.js';
import Toastify from 'toastify-js';
import { useCart, CartProvider } from './CartContext';
import CheckoutOrBrowseProducts from './checkout_or_browse_products';
import EventRegistrationHeader from './event_registration_header';
import PurchaseSidebar from './purchase_sidebar';
import { ErrorBoundary } from 'react-error-boundary';

const DirectPaymentFormContent = ({
  camper,
  camp_id,
  csrfToken,
  selected_price_point_id,
  waitlist_invitation,
  waitlist_entry_id,
  buttonStyles,
  event_title,
  date_range,
  time_range,
  event_image_url
}) => {
  // Ensure camper is provided
  if (!camper) {
    return <div>Error: Camper information is not available.</div>;
  }

  const { refreshCart } = useCart();
  const [loadingPayment, setLoadingPayment] = useState(false);
  const [step, setStep] = useState(1); // 1: add registration; 2: checkout/browse
  const [currentCamper] = useState(camper.id);

  const updateCartCountDisplay = (newCount) => {
    const countElements = document.querySelectorAll('.cart-items-count');
    countElements.forEach(element => {
      element.textContent = newCount;
    });
  };

  const addToCart = async (event) => {
    if (event) event.preventDefault();
    setLoadingPayment(true);

    const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

    const registrationData = {
      registration: {
        camper_id: currentCamper,
        liability_waiver: true, // assume waiver is already handled
        price_point_id: selected_price_point_id,
        waitlist_invitation: waitlist_invitation,
        waitlist_entry_id: waitlist_entry_id,
        camp_id: camp_id
      }
    };

    try {
      const response = await fetch(`/camps/${camp_id}/registrations`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify(registrationData)
      });
      const data = await response.json();
      console.log(data)
      if (!response.ok) {
        throw new Error(`Failed to add to cart: ${data.error || 'Unknown error'}`);
      }
      updateCartCountDisplay(data.cart_items_count);
      refreshCart();
      Toastify({
        text: "Registration added to cart.",
        duration: 3000
      }).showToast();
      setStep(2);
    } catch (error) {
      console.error('Error adding to cart:', error);
      Toastify({
        text: `Error: ${error.message}`,
        duration: 3000
      }).showToast();
    } finally {
      setLoadingPayment(false);
    }
  };

  useEffect(() => {
    const target = document.getElementById('loading-spinner');
    if (target && loadingPayment) {
      const spinner = new Spinner({ color: "#fff", lines: 10, speed: 1 }).spin(target);
      return () => spinner.stop();
    }
  }, [loadingPayment]);

  return (
    <div className="registration-content">
      <EventRegistrationHeader 
        title={event_title} 
        dateRange={date_range}
        timeRange={time_range}
        imageUrl={event_image_url}
      />
      <div className="registration-flow">
        {step === 1 && (
          <form className="new-step-form" method="POST" action={`/camps/${camp_id}/registrations`}>
            <div className="purchase-recap price-point-options">
              <div className="payment-column">
                <input name="utf8" type="hidden" value="✓" />
                <input name="authenticity_token" type="hidden" value={csrfToken} />
                <input name="registration[camper_id]" type="hidden" value={currentCamper} />
                <input name="registration[price_point_id]" type="hidden" value={selected_price_point_id} />
                <div id="loading-spinner" />
              </div>
              <div className="camper-info-row">
                <button
                  type="button"
                  className="button button-primary create payment-button"
                  style={{ ...buttonStyles, backgroundColor: '#4CAF50', color: '#FFF' }}
                  disabled={loadingPayment}
                  onClick={addToCart}
                >
                  Add Registration to Cart
                </button>
              </div>
            </div>
          </form>
        )}
        {step === 2 && <div className="new-step-form"><CheckoutOrBrowseProducts /></div>}
      </div>
    </div>
  );
};

const DirectPaymentForm = (props) => {
  return (
    <CartProvider>
      <StrictMode>
        <ErrorBoundary FallbackComponent={() => <div>Error occurred.</div>}>
          <DirectPaymentFormContent {...props} />
          <PurchaseSidebar />
        </ErrorBoundary>
      </StrictMode>
    </CartProvider>
  );
};

export default DirectPaymentForm;
